import { render, staticRenderFns } from "./InstallationRelationsList.vue?vue&type=template&id=48662d8b&"
import script from "./InstallationRelationsList.vue?vue&type=script&lang=js&"
export * from "./InstallationRelationsList.vue?vue&type=script&lang=js&"
import style0 from "./InstallationRelationsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports